(function () {
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var parcelRequire = $parcel$global["parcelRequire7c47"];
parcelRequire.register("9ywsj", function(module, exports) {
parcelRequire("6qcK6");
parcelRequire("lzblW");
parcelRequire("hlTU3");
parcelRequire("kSkug");
parcelRequire("3ZHxY");

});
parcelRequire.register("6qcK6", function(module, exports) {
parcelRequire("3gsTl");
parcelRequire("6g0ya");
parcelRequire("iT7pl");
parcelRequire("kN2au");

});
parcelRequire.register("3gsTl", function(module, exports) {
"use strict";
const $2609470222b1659f$var$widgets = document.querySelectorAll(".widget_categories, .widget_nav_menu, .widget_pages");
const $2609470222b1659f$var$arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512">
<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
</svg>`;
$2609470222b1659f$var$widgets.forEach((widget)=>{
    const title = widget.querySelector(".widgettitle");
    if (!title) return;
    title.insertAdjacentHTML("beforeend", `<span class="widget__dropdown-btn">${$2609470222b1659f$var$arrowSvg}</span>`);
    const dropdownButton = title.querySelector(".widget__dropdown-btn");
    const handleSubmenu = (event)=>{
        event.preventDefault();
        widget.classList.toggle("--open");
    };
    dropdownButton?.addEventListener("click", handleSubmenu);
});

});

parcelRequire.register("6g0ya", function(module, exports) {
parcelRequire("7oN3a");
parcelRequire("8TwYC");
parcelRequire("kNzkh");

});
parcelRequire.register("7oN3a", function(module, exports) {
"use strict";
// image wraped with link -> added data-facnybox attribute to envoke fancybox (exept gallery items)
// example:
//<a href="images/content/sample-02.jpg">
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
// Converts to:
//<a href="images/content/sample-02.jpg" data-fancybox>
// <img src="" data-src="https://source.unsplash.com/300x368/?giraffe" alt="">
//</a>
const $5630d2a021cd5f07$var$links = document.querySelectorAll(".entry-content .kt-img-link, .entry-content a");
$5630d2a021cd5f07$var$links.forEach((link)=>{
    const image = link.querySelector(':scope[href$=".jpg"] > img, :scope[href$=".png"] > img, :scope[href$=".jpeg"] > img');
    if (!image) return;
    link.setAttribute("data-fancybox", "");
    const alignsClasses = [
        "aligncenter",
        "alignright",
        "alignleft"
    ];
    alignsClasses.forEach((align)=>{
        if (!image.classList.contains(align)) return;
        image.classList.remove(align);
        link.classList.add(align);
    });
});

});

parcelRequire.register("8TwYC", function(module, exports) {
"use strict";
const $679d0a49f8589b30$var$iframes = document.querySelectorAll(".entry-content iframe");
$679d0a49f8589b30$var$iframes.forEach((iframe)=>{
    const iframeSrc = iframe.getAttribute("src");
    if (iframeSrc === null) return;
    if (iframeSrc.indexOf("youtube") !== -1) {
        iframe.classList.add("embed-responsive-item");
        iframe.removeAttribute("height");
        iframe.removeAttribute("width");
        const iframeWrap = document.createElement("div");
        iframeWrap.classList.add("ratio", "ratio-16x9");
        iframe.parentNode?.insertBefore(iframeWrap, iframe);
        iframeWrap.appendChild(iframe);
    }
});

});

parcelRequire.register("kNzkh", function(module, exports) {
"use strict";
const $f243c94214d844ef$var$removeWidthHeight = (selector)=>{
    const elements = document.querySelectorAll(selector);
    elements.forEach((element)=>{
        element.removeAttribute("width");
        element.removeAttribute("height");
        element?.style.setProperty("width", null);
        element?.style.setProperty("height", null);
    });
};
$f243c94214d844ef$var$removeWidthHeight(".entry-content table");
$f243c94214d844ef$var$removeWidthHeight(".entry-content tr");
$f243c94214d844ef$var$removeWidthHeight(".entry-content th");
$f243c94214d844ef$var$removeWidthHeight(".entry-content td");

});


parcelRequire.register("iT7pl", function(module, exports) {
// Added submenu button, in order to dropdown submenu
// Style sub-menu__button element to your needs
const $dc031c1106284b94$var$arrowSvg = `<svg xmlns="http://www.w3.org/2000/svg" width="16px" viewBox="0 0 512 512">
<path d="M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"/>
</svg>`;
const $dc031c1106284b94$var$itemsWithSubmenu = document.querySelectorAll(".menu-item-has-children, .page_item_has_children");
$dc031c1106284b94$var$itemsWithSubmenu.forEach((item)=>{
    item.insertAdjacentHTML("beforeend", `<span class="sub-menu__button">${$dc031c1106284b94$var$arrowSvg}</span>`);
    const submenuButton = item.querySelector(".sub-menu__button");
    const handleSubmenu = (event)=>{
        event.preventDefault();
        item.classList.toggle("--open");
    };
    submenuButton?.addEventListener("click", handleSubmenu);
});

});

parcelRequire.register("kN2au", function(module, exports) {
"use strict";
const $f22a10cefcbbd4c3$var$initGallery = (gallerySelector, galleryLinkSelector, postfix = "I")=>{
    const galleries = document.querySelectorAll(gallerySelector);
    let galleryId = `gallery-${postfix}`;
    galleries.forEach((gallery)=>{
        const links = gallery.querySelectorAll(galleryLinkSelector);
        links.forEach((link)=>{
            link.setAttribute("data-fancybox", galleryId);
        });
        galleryId += postfix;
    });
};
$f22a10cefcbbd4c3$var$initGallery(".gallery", ".gallery-icon a");
$f22a10cefcbbd4c3$var$initGallery(".wp-block-gallery", ".blocks-gallery-item a", "W");

});


parcelRequire.register("lzblW", function(module, exports) {

var $5Tf5z = parcelRequire("5Tf5z");
(0, $5Tf5z.polyfill)();
const $fb35ac4911525476$var$scrollUpElement = document.getElementById("c-scroll-up");
if ($fb35ac4911525476$var$scrollUpElement !== null) {
    const offsetFromTop = Number($fb35ac4911525476$var$scrollUpElement.getAttribute("data-offset-from-top")) ?? 100; // if not set default is 100px
    const isInLimit = ()=>document.body.scrollTop > offsetFromTop || document.documentElement.scrollTop > offsetFromTop;
    const scrollHandle = ()=>{
        $fb35ac4911525476$var$scrollUpElement.classList.toggle("--active", isInLimit());
    };
    const scrollTop = ()=>{
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };
    window.addEventListener("scroll", scrollHandle);
    $fb35ac4911525476$var$scrollUpElement.addEventListener("click", scrollTop);
}

});
parcelRequire.register("5Tf5z", function(module, exports) {
/* smoothscroll v0.4.4 - 2019 - Dustan Kasten, Jeremias Menichelli - MIT License */ (function() {
    "use strict";
    // polyfill
    function polyfill() {
        // aliases
        var w = window;
        var d = document;
        // return if scroll behavior is supported and polyfill is not forced
        if ("scrollBehavior" in d.documentElement.style && w.__forceSmoothScrollPolyfill__ !== true) return;
        // globals
        var Element = w.HTMLElement || w.Element;
        var SCROLL_TIME = 468;
        // object gathering original scroll methods
        var original = {
            scroll: w.scroll || w.scrollTo,
            scrollBy: w.scrollBy,
            elementScroll: Element.prototype.scroll || scrollElement,
            scrollIntoView: Element.prototype.scrollIntoView
        };
        // define timing method
        var now = w.performance && w.performance.now ? w.performance.now.bind(w.performance) : Date.now;
        /**
     * indicates if a the current browser is made by Microsoft
     * @method isMicrosoftBrowser
     * @param {String} userAgent
     * @returns {Boolean}
     */ function isMicrosoftBrowser(userAgent) {
            var userAgentPatterns = [
                "MSIE ",
                "Trident/",
                "Edge/"
            ];
            return new RegExp(userAgentPatterns.join("|")).test(userAgent);
        }
        /*
     * IE has rounding bug rounding down clientHeight and clientWidth and
     * rounding up scrollHeight and scrollWidth causing false positives
     * on hasScrollableSpace
     */ var ROUNDING_TOLERANCE = isMicrosoftBrowser(w.navigator.userAgent) ? 1 : 0;
        /**
     * changes scroll position inside an element
     * @method scrollElement
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function scrollElement(x, y) {
            this.scrollLeft = x;
            this.scrollTop = y;
        }
        /**
     * returns result of applying ease math function to a number
     * @method ease
     * @param {Number} k
     * @returns {Number}
     */ function ease(k) {
            return 0.5 * (1 - Math.cos(Math.PI * k));
        }
        /**
     * indicates if a smooth behavior should be applied
     * @method shouldBailOut
     * @param {Number|Object} firstArg
     * @returns {Boolean}
     */ function shouldBailOut(firstArg) {
            if (firstArg === null || typeof firstArg !== "object" || firstArg.behavior === undefined || firstArg.behavior === "auto" || firstArg.behavior === "instant") // first argument is not an object/null
            // or behavior is auto, instant or undefined
            return true;
            if (typeof firstArg === "object" && firstArg.behavior === "smooth") // first argument is an object and behavior is smooth
            return false;
            // throw error when behavior is not supported
            throw new TypeError("behavior member of ScrollOptions " + firstArg.behavior + " is not a valid value for enumeration ScrollBehavior.");
        }
        /**
     * indicates if an element has scrollable space in the provided axis
     * @method hasScrollableSpace
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function hasScrollableSpace(el, axis) {
            if (axis === "Y") return el.clientHeight + ROUNDING_TOLERANCE < el.scrollHeight;
            if (axis === "X") return el.clientWidth + ROUNDING_TOLERANCE < el.scrollWidth;
        }
        /**
     * indicates if an element has a scrollable overflow property in the axis
     * @method canOverflow
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function canOverflow(el, axis) {
            var overflowValue = w.getComputedStyle(el, null)["overflow" + axis];
            return overflowValue === "auto" || overflowValue === "scroll";
        }
        /**
     * indicates if an element can be scrolled in either axis
     * @method isScrollable
     * @param {Node} el
     * @param {String} axis
     * @returns {Boolean}
     */ function isScrollable(el) {
            var isScrollableY = hasScrollableSpace(el, "Y") && canOverflow(el, "Y");
            var isScrollableX = hasScrollableSpace(el, "X") && canOverflow(el, "X");
            return isScrollableY || isScrollableX;
        }
        /**
     * finds scrollable parent of an element
     * @method findScrollableParent
     * @param {Node} el
     * @returns {Node} el
     */ function findScrollableParent(el) {
            while(el !== d.body && isScrollable(el) === false)el = el.parentNode || el.host;
            return el;
        }
        /**
     * self invoked function that, given a context, steps through scrolling
     * @method step
     * @param {Object} context
     * @returns {undefined}
     */ function step(context) {
            var time = now();
            var value;
            var currentX;
            var currentY;
            var elapsed = (time - context.startTime) / SCROLL_TIME;
            // avoid elapsed times higher than one
            elapsed = elapsed > 1 ? 1 : elapsed;
            // apply easing to elapsed time
            value = ease(elapsed);
            currentX = context.startX + (context.x - context.startX) * value;
            currentY = context.startY + (context.y - context.startY) * value;
            context.method.call(context.scrollable, currentX, currentY);
            // scroll more if we have not reached our destination
            if (currentX !== context.x || currentY !== context.y) w.requestAnimationFrame(step.bind(w, context));
        }
        /**
     * scrolls window or element with a smooth behavior
     * @method smoothScroll
     * @param {Object|Node} el
     * @param {Number} x
     * @param {Number} y
     * @returns {undefined}
     */ function smoothScroll(el, x, y) {
            var scrollable;
            var startX;
            var startY;
            var method;
            var startTime = now();
            // define scroll context
            if (el === d.body) {
                scrollable = w;
                startX = w.scrollX || w.pageXOffset;
                startY = w.scrollY || w.pageYOffset;
                method = original.scroll;
            } else {
                scrollable = el;
                startX = el.scrollLeft;
                startY = el.scrollTop;
                method = scrollElement;
            }
            // scroll looping over a frame
            step({
                scrollable: scrollable,
                method: method,
                startTime: startTime,
                startX: startX,
                startY: startY,
                x: x,
                y: y
            });
        }
        // ORIGINAL METHODS OVERRIDES
        // w.scroll and w.scrollTo
        w.scroll = w.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scroll.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : w.scrollX || w.pageXOffset, // use top prop, second argument if present or fallback to scrollY
                arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : w.scrollY || w.pageYOffset);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, arguments[0].left !== undefined ? ~~arguments[0].left : w.scrollX || w.pageXOffset, arguments[0].top !== undefined ? ~~arguments[0].top : w.scrollY || w.pageYOffset);
        };
        // w.scrollBy
        w.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0])) {
                original.scrollBy.call(w, arguments[0].left !== undefined ? arguments[0].left : typeof arguments[0] !== "object" ? arguments[0] : 0, arguments[0].top !== undefined ? arguments[0].top : arguments[1] !== undefined ? arguments[1] : 0);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(w, d.body, ~~arguments[0].left + (w.scrollX || w.pageXOffset), ~~arguments[0].top + (w.scrollY || w.pageYOffset));
        };
        // Element.prototype.scroll and Element.prototype.scrollTo
        Element.prototype.scroll = Element.prototype.scrollTo = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                // if one number is passed, throw error to match Firefox implementation
                if (typeof arguments[0] === "number" && arguments[1] === undefined) throw new SyntaxError("Value could not be converted");
                original.elementScroll.call(this, // use left prop, first number argument or fallback to scrollLeft
                arguments[0].left !== undefined ? ~~arguments[0].left : typeof arguments[0] !== "object" ? ~~arguments[0] : this.scrollLeft, // use top prop, second argument or fallback to scrollTop
                arguments[0].top !== undefined ? ~~arguments[0].top : arguments[1] !== undefined ? ~~arguments[1] : this.scrollTop);
                return;
            }
            var left = arguments[0].left;
            var top = arguments[0].top;
            // LET THE SMOOTHNESS BEGIN!
            smoothScroll.call(this, this, typeof left === "undefined" ? this.scrollLeft : ~~left, typeof top === "undefined" ? this.scrollTop : ~~top);
        };
        // Element.prototype.scrollBy
        Element.prototype.scrollBy = function() {
            // avoid action when no arguments are passed
            if (arguments[0] === undefined) return;
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.elementScroll.call(this, arguments[0].left !== undefined ? ~~arguments[0].left + this.scrollLeft : ~~arguments[0] + this.scrollLeft, arguments[0].top !== undefined ? ~~arguments[0].top + this.scrollTop : ~~arguments[1] + this.scrollTop);
                return;
            }
            this.scroll({
                left: ~~arguments[0].left + this.scrollLeft,
                top: ~~arguments[0].top + this.scrollTop,
                behavior: arguments[0].behavior
            });
        };
        // Element.prototype.scrollIntoView
        Element.prototype.scrollIntoView = function() {
            // avoid smooth behavior if not required
            if (shouldBailOut(arguments[0]) === true) {
                original.scrollIntoView.call(this, arguments[0] === undefined ? true : arguments[0]);
                return;
            }
            // LET THE SMOOTHNESS BEGIN!
            var scrollableParent = findScrollableParent(this);
            var parentRects = scrollableParent.getBoundingClientRect();
            var clientRects = this.getBoundingClientRect();
            if (scrollableParent !== d.body) {
                // reveal element inside parent
                smoothScroll.call(this, scrollableParent, scrollableParent.scrollLeft + clientRects.left - parentRects.left, scrollableParent.scrollTop + clientRects.top - parentRects.top);
                // reveal parent in viewport unless is fixed
                if (w.getComputedStyle(scrollableParent).position !== "fixed") w.scrollBy({
                    left: parentRects.left,
                    top: parentRects.top,
                    behavior: "smooth"
                });
            } else // reveal element in viewport
            w.scrollBy({
                left: clientRects.left,
                top: clientRects.top,
                behavior: "smooth"
            });
        };
    }
    // commonjs
    module.exports = {
        polyfill: polyfill
    };
})();

});


parcelRequire.register("hlTU3", function(module, exports) {
const $ca1fc30271ca302f$var$transitionLength = 300;
const $ca1fc30271ca302f$var$openModal = (modal)=>{
    modal.classList.add("--open");
    modal.classList.remove("--hidden");
};
const $ca1fc30271ca302f$var$closeModal = (modal)=>{
    modal.classList.remove("--open");
    setTimeout(()=>{
        modal.classList.add("--hidden");
    }, $ca1fc30271ca302f$var$transitionLength);
};
const $ca1fc30271ca302f$var$initTriggers = ()=>{
    const triggers = document.querySelectorAll("[data-modal-target]");
    triggers.forEach((trigger)=>{
        const modalTarget = document.getElementById(trigger.getAttribute("data-modal-target") ?? "");
        if (modalTarget === null) return;
        trigger.addEventListener("click", (event)=>{
            event.preventDefault();
            $ca1fc30271ca302f$var$openModal(modalTarget);
        });
    });
};
const $ca1fc30271ca302f$var$initModals = ()=>{
    const modals = document.querySelectorAll(".c-modal");
    modals.forEach((modal)=>{
        const closeButtons = document.querySelectorAll(".c-modal__close");
        modal.style.setProperty("--transtion-length", `${$ca1fc30271ca302f$var$transitionLength}ms`);
        closeButtons.forEach((closeButton)=>{
            closeButton.addEventListener("click", (event)=>{
                event.preventDefault();
                $ca1fc30271ca302f$var$closeModal(modal);
            });
        });
        modal.addEventListener("click", (event)=>{
            if (modal == event.target) $ca1fc30271ca302f$var$closeModal(modal);
        });
    });
};
// In case needed reinitialize modals
// When something is re rendered
const $ca1fc30271ca302f$var$init = ()=>{
    $ca1fc30271ca302f$var$initTriggers();
    $ca1fc30271ca302f$var$initModals();
};
var $ca1fc30271ca302f$export$2e2bcd8739ae039 = $ca1fc30271ca302f$var$init;
$ca1fc30271ca302f$var$init();

});

parcelRequire.register("kSkug", function(module, exports) {
const $f328be1b00e2558f$var$faqs = document.querySelectorAll(".i-info-item");
$f328be1b00e2558f$var$faqs.forEach((faq)=>{
    const header = faq.querySelector(".i-info-item__header");
    header?.addEventListener("click", ()=>{
        faq.classList.toggle("--open");
    });
});

});

parcelRequire.register("3ZHxY", function(module, exports) {
const $2e88d920c6232824$var$items = document.querySelectorAll(".i-info");
$2e88d920c6232824$var$items.forEach((item)=>{
    const opener = item.querySelector(".i-info__opener");
    const closer = item.querySelector(".i-info__closer");
    opener?.addEventListener("click", ()=>{
        item.classList.add("--open");
    });
    closer?.addEventListener("click", ()=>{
        item.classList.remove("--open");
    });
});

});


})();
//# sourceMappingURL=main.e492ce3f.js.map
